import { algoliasearch } from 'algoliasearch';

type AlgoliaClientType = ReturnType<typeof algoliasearch>;

let _client: AlgoliaClientType | null = null;

/**
 * Algoliaクライアントを遅延初期化で取得する
 * モジュール読み込み時ではなく、実際に使用する時点で環境変数をチェックする
 */
export const getAlgoliaClient = (): AlgoliaClientType => {
  if (_client) return _client;

  const appId = process.env.REACT_APP_ALGOLIA_APP_ID;
  const searchApiKey = process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY;

  if (!appId || !searchApiKey) {
    throw new Error('REACT_APP_ALGOLIA_APP_ID and REACT_APP_ALGOLIA_SEARCH_API_KEY must be set');
  }

  _client = algoliasearch(appId, searchApiKey);
  return _client;
};

/**
 * 環境に応じたインデックス名を返す
 */
export const getResultsIndexName = (): string => {
  const env = process.env.REACT_APP_ALGOLIA_ENV || 'local';
  return `results_${env}`;
};
